import * as z from 'zod'

import {queries} from '@/shared/integrations/zero'
import {QueryResultType} from '@rocicorp/zero'
import {SortSchema} from '@cypro/ui/schemas'

export type EventLogExtended = QueryResultType<typeof queries.eventLogs.getEventById> & {id: string}

export const SystemLogsSearchSchema = z.object({
  multiFilters: z
    .array(
      z.discriminatedUnion('id', [
        z.object({
          id: z.literal('performedAt'),
          value: z.array(z.number()).optional(),
          operator: z.enum(['IS EMPTY', 'IS NOT EMPTY', 'IS BETWEEN', '=', '<', '<=', '>', '>=', '!=']),
        }),
        z.object({
          id: z.enum(['status', 'resource', 'domain', 'action', 'performedBy']),
          value: z.array(z.string()).optional(),
          operator: z.enum(['IS EMPTY', 'IS NOT EMPTY', 'IN', 'NOT IN']),
        }),
      ])
    )
    .optional(),
  filters: z
    .object({
      search: z.string().optional(),
    })
    .optional(),
  sort: z.array(SortSchema).default([{id: 'performedAt', desc: true}]),
})

export type Filter =
  | {
      id: 'performedAt'
      operator: 'IS EMPTY' | 'IS NOT EMPTY' | 'IS BETWEEN' | '=' | '<' | '<=' | '>' | '>=' | '!='
      value?: number[]
    }
  | {
      id: 'status' | 'resource' | 'domain' | 'action' | 'performedBy'
      operator: 'IS EMPTY' | 'IS NOT EMPTY' | 'IN' | 'NOT IN'
      value?: string[]
    }
